import {
  APIContextOptions,
  createAPIContext,
  createBookingAPIv2,
  createCheckinSessionAPI,
  createConsentAPIv1,
  createConsentAPIv2,
  createPatientAPI,
  createQuestionnaireAPI,
  createScanAPI,
  createScheduleAPI,
  createUserAPI,
  createVisitAPI,
  createSiteAPI,
} from "@cur8/api-client";

export function createClient(options: APIContextOptions) {
  const context = createAPIContext(options);

  return {
    booking: createBookingAPIv2(context),
    checkinSession: createCheckinSessionAPI(context),
    consent: createConsentAPIv1(context),
    consentV2: createConsentAPIv2(context),
    patient: createPatientAPI(context),
    scan: createScanAPI(context),
    schedule: createScheduleAPI(context),
    site: createSiteAPI(context),
    user: createUserAPI(context),
    visit: createVisitAPI(context),
    questionnaire: createQuestionnaireAPI(context),
  };
}

export type APIClient = ReturnType<typeof createClient>;
